module.exports = __webpack_public_path__ + "img/slider-arrow-prev.9234fdec13c2b5fd8c9b260ebdaf561e.svg";